var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgXataBrand = function SvgXataBrand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 133,
    viewBox: "0 0 463 133",
    fill: "#515151",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7104 133L51.0426 82.445L28.3253 133H0L34.8839 65.6559L0.570309 2.25106H29.0857L52.4684 52.1495L75.0906 2.25106H103.036L68.437 68.0007L103.986 133H74.7104Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.579 114.054H180.911H157.243L150.209 133H123.595L179.675 0H181.576L237.847 133H211.993L204.579 114.054ZM204.579 114.054L183.668 60.2158L180.436 49.7109L177.394 60.2158L157.243 114.054H180.911H204.579Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.173 23.4485H305.567V133H281.043V23.4485H250.437V2.25106H336.173V23.4485Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M429.732 114.054H382.396L375.363 133H348.748L404.829 0H406.73L463 133H437.146L429.732 114.054ZM429.732 114.054L408.821 60.2158L405.589 49.7109L402.547 60.2158L382.396 114.054H429.732Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXataBrand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xata-brand.b5870747.svg";
export { ForwardRef as ReactComponent };